/** @jsxImportSource @emotion/react */
import React from 'react';
import { Layout, Button } from 'antd';
import ChunghwaLogo from './img/logos/ChunghwaLogo.svg';
import {containerStyle, headerStyle, contentStyle, footerStyle, logoStyle, textStyle, textStyle_TC, bigTextStyle, grayTextStyle, buttonStyle} from './AppStyle';

const { Header, Content, Footer } = Layout;


function App() {
	const redirectToIndex = () => {
		window.location.href = 'https://msecurity.hinet.net/msecurity/';
	};

	return (
		<Layout css={containerStyle}>
			<Header css={headerStyle}>
				<img src={ChunghwaLogo} alt="logo"  css={logoStyle}/>
			</Header>

			<Content css={contentStyle}>
				<p css={bigTextStyle}>
					操作錯誤
				</p>
				<p css={textStyle}>
					如有操作問題，請洽 24小時客戶服務專線
				</p>
				<p css={grayTextStyle}>
					0800-080-123(中華市話、行動直撥123)
				</p>

				<Button css={buttonStyle} onClick={redirectToIndex}>返回首頁</Button>
			</Content>

			<Footer css={footerStyle}>
				<div css={textStyle_TC}>
					中華電信股份有限公司版權所有
					<span css={textStyle}>
						© All Rights Reserved.
					</span>
				</div>
			</Footer>
		</Layout>
	);
};
export default App;
